export class SDIResponseObject {
  public Code: number;
  public Message: string;
  public Url: string;
}

export class InfoEsitoSDIObject {
  public DataCreazione: string;
  public Titolo: string;
  public Descrizione: string;
  public Messaggio: string;
}

export class JsonResult {
  public ContentType: string;
  public SerializerSettings: object;
  public StatusCode: number;
  public Value: object;
}
